import { apiService } from './apiService';
import { TermsDocumentsData } from '../types/terms';

/**
 * Fetch the legal documents (WTOU + EUTC). GET /api/terms is public, but the
 * shared apiService is used so behaviour (base URL, retries) stays consistent.
 */
export const getTermsDocuments = async (): Promise<TermsDocumentsData> => {
  try {
    const response = await apiService.get<TermsDocumentsData>('/terms');
    if (response?.success && response?.data) {
      return response.data;
    }
    throw new Error(response?.message || 'Failed to load terms documents');
  } catch (error: any) {
    console.error('[Terms API] Error fetching terms documents:', error);
    throw new Error(error?.message || 'Failed to load terms documents');
  }
};

/** Record the authenticated user's acceptance of the current EUTC version. */
export const acceptEutc = async (): Promise<void> => {
  try {
    const response = await apiService.post('/auth/accept-eutc');
    if (!response?.success) {
      throw new Error(response?.message || 'Failed to record acceptance');
    }
  } catch (error: any) {
    console.error('[Terms API] Error accepting EUTC:', error);
    throw new Error(error?.message || 'Failed to record acceptance');
  }
};

/**
 * Set a new password for the authenticated user (forced first-login change).
 * Backend rule: at least 8 characters with at least one letter and one number.
 * The current Firebase session stays valid — no re-login is needed.
 */
export const changeOwnPassword = async (newPassword: string): Promise<void> => {
  try {
    const response = await apiService.post('/auth/change-password', { newPassword });
    if (!response?.success) {
      throw new Error(response?.message || 'Failed to change password');
    }
  } catch (error: any) {
    console.error('[Terms API] Error changing password:', error);
    throw new Error(error?.message || 'Failed to change password');
  }
};
